export default __webpack_public_path__ + "static/media/training-testimonials-top-image.8ccd7021.png";